module.exports = __webpack_public_path__ + "static/media/5. Perdida, Óleo, arenas y barniz en tela, 150 x 150 cm, 2019 copy.febba560.png";